import useStore, { selectCountryTheme } from '@/hooks/client/useStore';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

const css = {
  btn: (color, outlined) => ({
    color: outlined ? color : '#fff',
    border: `1.5px solid ${color}`,
    minHeight: '56px',
    backgroundColor: outlined ? '#fff' : color,
    width: '100%',
    fontSize: '16px',
    fontWeight: '400',
    borderRadius: 3,
  }),
};

/**
 * Button used in recipes, has 2 styles outlined and contained
 * @returns {JSX.Element}
 */
const SecondaryButton = ({ text, onClick, sx = {}, outlined = false, ...props }) => {
  const countryTheme = useStore(selectCountryTheme);

  return (
    <Button
      {...props}
      onClick={onClick}
      aria-label={text}
      sx={{
        ...css.btn(countryTheme.navColor, outlined),
        ...sx,
      }}
    >
      {text}
    </Button>
  );
};

SecondaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  sx: PropTypes.string,
  outlined: PropTypes.bool,
};

export default SecondaryButton;
